<script lang="ts" setup>
import { menu } from '@/.';
import type { MenuItem } from '@/objects';
import { computed } from 'vue';

const menuItems = computed(() => {
    let items: MenuItem[] = [];

    menu.forEach((m) => {
        if (m.subItems && m.subItems.length > 0) {
            m.subItems.forEach((sm) => {
                if (sm.shortcutKey && sm.shortcutKey.length > 0) {
                    items.push(sm);
                }
            });
        } else if (m.shortcutKey && m.shortcutKey.length > 0) {
            items.push(m);
        }
    });

    return items;
});
</script>
<template>
    <div class="d-flex flex-column flex-md-row gap-4 px-2 mb-5">
        <div class="flex-fill flex-grow-0">
            <h4>{{ $tm('keyboard.globalevents') }}</h4>

            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border">CTRL+F1</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.showviewhelp') }}
                </div>
            </div>

            <h5 class="mt-5">{{ $tm('keyboardshortcuts.menuitems') }}</h5>

            <div
                v-for="(mi, i) in menuItems"
                :key="i"
                class="row"
            >
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">{{ mi.shortcutKey }}</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm(mi.translationKey) }}
                </div>
            </div>

            <h5 class="mt-5">{{ $tm('keyboardshortcuts.tabs') }}</h5>
            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">CTRL+ALT+1-9</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.tabsnumbers') }}
                </div>
            </div>
            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">CTRL+ALT+TAB</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.tabslast') }}
                </div>
            </div>

            <h5 class="mt-5">{{ $tm('keyboardshortcuts.general') }}</h5>
            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">CTRL+ENTER</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.submit') }}
                </div>
            </div>

            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">CTRL+SPACE</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.focusfirst') }}
                </div>
            </div>
            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">CTRL+K</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.globalsearch') }}
                </div>
            </div>

            <div class="row">
                <div class="col-5 col-lg-3">
                    <code class="shadow-sm p-1 px-2 bg-body-tertiary rounded border me-3">CTRL+ALT+SPACE</code>
                </div>
                <div class="col-7 col-lg-9">
                    {{ $tm('keyboardshortcuts.focusfirsterror') }}
                </div>
            </div>
        </div>

        <div class="flex-fill">
            <h4>{{ $tm('keyboard.viewevents') }}</h4>
        </div>
    </div>
</template>
